import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import EmptyCell from './EmptyCell';
import ClassNames from './EmptyCell.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* Data wrapper for the empty cell widget.
*/
export default class EmptyCellWidget extends BaseWidget {
  static displayName = 'EmptyCellWidget';
  static propTypes = {
    type: PropTypes.string,
    config: PropTypes.object,
    classes: PropTypes.object,
    style: PropTypes.object
  };
  static defaultProps = {
    classes: ClassNames
  };
  render() {
    const { classes, style } = this.props;
    return (
      <EmptyCell
        {...resolveTestId(this.props)}
        classes={classes}
        style={this.getStyleObject(style)} />
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/EmptyCell/EmptyCellWidget.js